import React from "react"
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import Switch from "react-switch"

function VenueSession({
  validation,
  toggleSection = () => { },
  openSection,
  addSession,
  removeSession,
}) {
  return (
    <>
      <div className="card border-0 shadow-sm p-3 ">
        <div className="d-flex justify-content-between align-items-center">
          <span className="fw-semibold">Enable Session</span>
          <Switch
            checked={!!validation.values.enable_sessions}
            onChange={(checked) => {
              validation.setFieldValue("enable_sessions", checked)

              if (checked && validation.values.sessions.length === 0) {
                validation.setFieldValue("sessions", [
                  {
                    sessionName: "",
                    zone: "",
                    description: "",
                    startDateTime: "",
                    endDateTime: "",
                    gateScanning: false,
                  },
                ])
              }

              if (!checked) {
                validation.setFieldValue("sessions", [])
              }
            }}
            onColor="#34c38f"
            offColor="#b3a692"
            uncheckedIcon={false}
            checkedIcon={false}
            height={16}
            width={32}
            handleDiameter={14}
          />
        </div>
      </div>

      <Col sm="12" className="px-3">
        <div className="mt-3">
          {validation.values.enable_sessions && (
            <div className="animate__animated animate__fadeIn">
              {validation.values.sessions.map((session, index) => (
                <Row
                  key={index}
                  className="p-4 mb-3 rounded border border-warning bg-warning bg-opacity-10"
                >
                  <Col md={11}>
                    <Row className="d-flex align-items-center g-3 mb-3">
                      <Col >
                        <Label htmlFor="sessionName"> Session Name </Label>
                        <Input
                          type="text"
                          placeholder="Session Name"
                          name={`sessions[${index}].sessionName`}
                          value={session.sessionName}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                        />
                        {validation.touched.sessions?.[index]
                          ?.sessionName &&
                          validation.errors.sessions?.[index]
                            ?.sessionName && (
                            <div className="text-danger small">
                              {
                                validation.errors.sessions[index]
                                  .sessionName
                              }
                            </div>
                          )}
                      </Col>
                      <Col >
                        <Label htmlFor="zone">Zone</Label>
                        <Input
                          type="text"
                          placeholder="Zone"
                          name={`sessions[${index}].zone`}
                          value={session.zone}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                        />
                        {validation.touched.sessions?.[index]?.zone &&
                          validation.errors.sessions?.[index]?.zone && (
                            <div className="text-danger small">
                              {validation.errors.sessions[index].zone}
                            </div>
                          )}
                      </Col>
                      <Col >
                        <Label htmlFor="description">Description </Label>
                        <Input
                          type="textarea"
                          rows="1"
                          placeholder="Session Description"
                          name={`sessions[${index}].description`}
                          value={session.description || ""}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                        />
                        {validation.touched.sessions?.[index]
                          ?.description &&
                          validation.errors.sessions?.[index]
                            ?.description && (
                            <div className="text-danger small">
                              {
                                validation.errors.sessions[index]
                                  .description
                              }
                            </div>
                          )}
                      </Col>
                    </Row>
                    <Row>
                      <Col >
                        <Label htmlFor="startDateTime"> Start Date</Label>
                        <Input
                          type="datetime-local"
                          name={`sessions[${index}].startDateTime`}
                          value={session.startDateTime}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                        />
                        {validation.touched.sessions?.[index]
                          ?.startDateTime &&
                          validation.errors.sessions?.[index]
                            ?.startDateTime && (
                            <div className="text-danger small">
                              {
                                validation.errors.sessions[index]
                                  .startDateTime
                              }
                            </div>
                          )}
                      </Col>
                      <Col >
                        <Label htmlFor="endDateTime">End Date</Label>
                        <Input
                          type="datetime-local"
                          name={`sessions[${index}].endDateTime`}
                          onBlur={validation.handleBlur}
                          value={session.endDateTime}
                          onChange={validation.handleChange}
                        />

                        {validation.touched.sessions?.[index]
                          ?.endDateTime &&
                          validation.errors.sessions?.[index]
                            ?.endDateTime && (
                            <div className="text-danger small">
                              {
                                validation.errors.sessions[index]
                                  .endDateTime
                              }
                            </div>
                          )}
                      </Col>
                      <Col className="d-flex align-items-center justify-content-center" >
                        <div
                          className="form-check form-switch "
                          onClick={e => e.stopPropagation()}
                          style={{ width: 100 }}
                        >
                          <Input
                            type="checkbox"
                            className="form-check-input me-2"
                            id={`sessions_${index}_gateScanning`}
                            name={`sessions[${index}].gateScanning`}
                            defaultChecked={
                              !!validation.values.sessions?.[index]
                                ?.gateScanning
                            }
                            onChange={validation.handleChange}

                          />
                          <Label
                            className="mb-0"
                            htmlFor={`sessions_${index}_gateScanning`}
                          >
                            Scan
                          </Label>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={1} className="d-flex justify-content-center align-items-center bg-danger bg-opacity-10">
                    <button
                      type="button"
                      className="btn btn-link text-danger p-0"
                      onClick={() => removeSession(index)}
                    >
                      <i className="mdi mdi-delete-outline fs-4"></i>
                    </button>
                  </Col>
                </Row>
              ))}

              <button
                type="button"
                className="btn btn-outline-dark btn-sm mt-2"
                onClick={() => {
                  const sessions = validation.values.sessions || []

                  if (sessions.length === 0) {
                    addSession()
                    return
                  }

                  const lastSession = sessions[sessions.length - 1]

                  const sessionName = lastSession.sessionName?.trim()
                  const zone = lastSession.zone?.trim()
                  const start = lastSession.startDateTime
                  const end = lastSession.endDateTime

                  if (!sessionName || !zone || !start || !end) {
                    alert(
                      "Please complete the previous session before adding another."
                    )
                    return
                  }

                  addSession()
                }}
              >
                <i className="mdi mdi-plus-circle-outline me-1"></i> Add
                Session
              </button>
            </div>
          )}
        </div>
      </Col>
    </>
  )
}

export default VenueSession
